import React from 'react'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartData,
} from 'chart.js'
import { Doughnut } from 'react-chartjs-2'
import { brandColors } from '@/pages/communal/statistics/components/common/const'
import { ActivityStatus } from '@/pages/communal/statistics/components/common/data'
import { Translates } from '@/services/repository/i18n'

ChartJS.register(ArcElement, Tooltip, Legend)

interface ActivityStatusChartProps {
  activityStatus: ActivityStatus
  chartTitle: string
  translationsKey: string
  translates: Translates
}

export const ActivityStatusChart: React.FC<ActivityStatusChartProps> = ({
  activityStatus, chartTitle, translationsKey, translates
}) => {
  const data: ChartData<'doughnut'> = {
    labels: [
      translates.for(`${translationsKey}.active`),
      translates.for(`${translationsKey}.fire`)
    ],
    datasets: [
      {
        data: [
          activityStatus.activeTime - activityStatus.onFireTime,
          activityStatus.onFireTime
        ],
        backgroundColor: [
          brandColors.normal,
          brandColors.good
        ],
        borderWidth: 0
      }
    ]
  }

  return (
    <Doughnut
      data={data}
      options={{
        responsive: true,
        plugins: {
          legend: { position: 'bottom' },
          title: { display: true, text: chartTitle },
        }
      }}
    />
  )
}